import { render, staticRenderFns } from "./AdConversions.vue?vue&type=template&id=34828c20&"
import script from "./AdConversions.vue?vue&type=script&lang=js&"
export * from "./AdConversions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34828c20')) {
      api.createRecord('34828c20', component.options)
    } else {
      api.reload('34828c20', component.options)
    }
    module.hot.accept("./AdConversions.vue?vue&type=template&id=34828c20&", function () {
      api.rerender('34828c20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Research/AdConversions.vue"
export default component.exports